import styles from './pages.module.css';

export function NoConversationPage() {
  return (
    <section className={styles.centered}>
      <h2 className={styles.heading}>Selecione uma conversa</h2>
      <p className={styles.muted}>Escolha uma conversa na lista para ver as mensagens.</p>
    </section>
  );
}
